import { render } from "./DPlayer.vue?vue&type=template&id=23794804"
import script from "./DPlayer.vue?vue&type=script&lang=js"
export * from "./DPlayer.vue?vue&type=script&lang=js"

import "./DPlayer.vue?vue&type=style&index=0&id=23794804&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__